var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottom25Amber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 12,
    viewBox: "0 0 32 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 8,
    height: 12,
    transform: "rotate(-180 8 12)",
    fill: "#DADF95"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 12,
    width: 1,
    height: 12,
    transform: "rotate(-180 32 12)",
    fill: "#63666E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 6.5,
    width: 6,
    height: 1,
    transform: "rotate(-180 31 6.5)",
    fill: "#63666E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 12,
    width: 1,
    height: 12,
    transform: "rotate(-180 25 12)",
    fill: "#63666E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 12,
    width: 7.5,
    height: 1,
    transform: "rotate(-180 24 12)",
    fill: "#63666E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 1,
    width: 7.5,
    height: 1,
    transform: "rotate(-180 24 1)",
    fill: "#63666E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 12,
    width: 1,
    height: 12,
    transform: "rotate(-180 16.5 12)",
    fill: "#63666E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 12,
    width: 7.5,
    height: 1,
    transform: "rotate(-180 15.5 12)",
    fill: "#63666E"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 1,
    width: 7.5,
    height: 1,
    transform: "rotate(-180 15.5 1)",
    fill: "#63666E"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 1,
    height: 12,
    transform: "rotate(-180 8 12)",
    fill: "#63666E"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 6.5,
    width: 6,
    height: 1,
    transform: "rotate(-180 7 6.5)",
    fill: "#63666E"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 12,
    width: 1,
    height: 12,
    transform: "rotate(-180 1 12)",
    fill: "#63666E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottom25Amber);
export default __webpack_public_path__ + "static/media/bottom25Amber.9cc6221e417b18fb1a723fbe3a615007.svg";
export { ForwardRef as ReactComponent };